import styled from 'styled-components'
import Colors from 'builder/styles/colors'
import { Icon20, Icon40 } from 'builder/components/Icon'
import Sizes from 'builder/styles/sizes'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${Sizes.M};
  padding: ${Sizes.L};
  background-color: ${Colors.White};
  border-radius: ${Sizes.S};
  box-shadow: 0px 6px 8px -2px rgba(15, 20, 30, 0.08), 0px 16px 64px -8px rgba(15, 20, 30, 0.32);
  width: 544px;
  position: relative;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Sizes.XS};
`

export const Title = styled.p`
  ${Typography.S};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};
`

export const SubTitle = styled.p`
  ${Typography.Body};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Sizes['2XS']};
`

export const CardContainer = styled.label`
  display: flex;
  gap: ${Sizes.S};
  padding: ${Sizes.M};
  border-radius: 16px;
  border: 1px solid ${Colors.Neutral20};
  background: ${Colors.White};
  cursor: pointer;
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: 0px 2px 4px -1px rgba(15, 56, 113, 0.08), 0px 8px 20px -4px rgba(15, 56, 113, 0.12);
  }
`

export const CardContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Sizes['2XS']};
  justify-content: center;
`

export const CardTitle = styled.p`
  ${Typography.Caption};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral90};
`

export const CardSubTitle = styled.p`
  ${Typography.Caption};
  ${FontWeights.Regular};
  color: ${Colors.Neutral50};
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 22px;
  border-radius: ${Sizes['2XS']};
  border: 1px solid ${Colors.Neutral15};
  background: linear-gradient(180deg, #f7f9fc 0%, #fff 100%);
  width: 84px;
  height: 84px;
  min-width: 84px;
  min-height: 84px;
  color: ${Colors.Neutral40};

  ${CardContainer}:hover & {
    color: ${Colors.Blue50};
  }
`

export const IconUpload = styled(Icon40.Upload)`
  width: 40px;
  height: 40px;
`

export const IconCreate = styled(Icon40.CreateDocument)`
  width: 40px;
  height: 40px;
`

export const DividerContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  width: 100%;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: linear-gradient(to right, transparent, rgba(0, 0, 0, 0.1));
  }

  &::after {
    background: linear-gradient(to left, transparent, rgba(0, 0, 0, 0.1));
  }
`

export const DividerText = styled.span`
  ${Typography.Caps};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral40};
  letter-spacing: 1.8px;
  text-transform: uppercase;
  padding: 0 20px;
`

export const CloseIconWrapper = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  top: 48px;
  right: 48px;

  ${Media.Phone`
    top: 5px;
    right: 5px;
  `}
`

export const CloseIcon = styled(Icon20.Close)`
  color: ${Colors.Neutral50};
  position: absolute;
  border-radius: 28px;
  width: 28px;
  height: 28px;
  padding: 4px;
  background: ${Colors.Neutral10};

  &:hover {
    background: ${Colors.Blue10};
    color: ${Colors.Blue50};
  }

  ${Media.Phone`
    width: 24px;
    height: 24px;
    padding: 2px;
    top: 20px;
    right: 20px;
  `};
`
